import React, { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ContactsView } from '../components';

export const GroupContactsPage: FC = () => {
  const { groupId } = useParams();
  const { state } = useLocation();

  return (
    <ContactsView
      groupId={groupId as string}
      isNew={state?.isNew}
      openDynamicRules={state?.openDynamicRules}
    />
  );
};
